// src/pages/Marturii.jsx
import React from "react";
import { Card, CardContent } from "../components/ui/Card";
import Title from "../components/ui/Title";

const testimoniale = [
  {
    nume: "Gabriela A.",
    tipProfil: "Manifestator 1/3",
    text: `Am făcut o analiză a designului meu cu Corina și este așa valoros și game changer să înțeleg care e strategia mea specifică de a naviga prin viață cu ușurință și satisfacție și care sunt reperele foarte specifice pe baza cărora iau deciziile potrivite! E un sistem complex și Corina îl face să fie foarte clar și practic.`
  },
  {
    nume: "Raluca S.",
    tipProfil: "Generator Manifestant 1/3 – absolventă de Psihologie",
    text: `Ce mi-a adus HD în toată treaba asta e multă liniște și am scăpat de multă vinovăție, am înțeles ca pot să fiu flexibilă în gândire și să mă răzgândesc de câte ori simt să fac asta, și asta nu mă face nebună, cum aș fi fost catalogată în psihologie. [...] HD mi-a adus mult mai mult decât psihologia, mi-a acceptat și onorat unicitatea și nu vine să te pună într-o categorie care să fie bună sau rea, cum e în psihologie (sănătos sau patologic). Și asta mi se pare cel mai mișto lucru și pe care îl apreciez și cu care rezonez cel mai mult în HD, că nu există blamare și judecată în niciun fel, ești așa cum ești, și odată ce accepți asta și te onorezi pe tine, viața devine dintr-o dată mult mai liniștită și mai frumoasă.`
  },
];

export default function Marturii() {
  return (
    <div className="p-6 md:p-12 max-w-5xl mx-auto text-text-body">
      <Title>Mărturii</Title>

      <p className="text-lg mb-8">
        Oameni care și-au dat voie să trăiască altfel – în acord cu natura lor unică.
        <br />
        Iată ce spun despre călătoria lor împreună cu mine și Human Design.
      </p>

      <div className="grid gap-6">
        {testimoniale.map((testim, index) => (
          <Card
            key={index}
            className="border border-brand-lavanda/40 bg-white/80 backdrop-blur-md shadow-brand transition transform hover:scale-[1.02] hover:shadow-xl duration-300"
          >
            <CardContent className="p-6">
              <p className="text-lg italic mb-4 whitespace-pre-line">„{testim.text}”</p>
              <p className="text-sm font-semibold">
                – {testim.nume}, {testim.tipProfil}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
